import { useEffect, useRef, useState, type ReactNode } from 'react';

/** Fit the existing board to the available pane, including a notebook's shorter viewport. */
export function EbookEditorBoardFrame({ children }: { children: ReactNode }) {
  const frame = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState<number>();
  useEffect(() => {
    const element = frame.current;
    if (!element) return;
    const fit = () => {
      const rect = element.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) setSize(Math.floor(Math.min(rect.width, rect.height)));
    };
    const observer = new ResizeObserver(fit);
    observer.observe(element);
    fit();
    return () => observer.disconnect();
  }, []);
  return (
    <div className="ebook-editor-board-frame" ref={frame}>
      <div
        className="ebook-editor-fitted-board"
        style={size === undefined ? undefined : { width: size, height: size }}
      >
        {children}
      </div>
    </div>
  );
}
